import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AuthContext';
import Logo from '../common/Logo';

export default function Navbar() {
    const { isLoggedIn, setIsLoggedIn, userName, setUserName } = useAppContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const authTokenFromSession = sessionStorage.getItem('auth-token');
        const nameFromSession = sessionStorage.getItem('name');
        if (authTokenFromSession && nameFromSession) {
            setUserName(nameFromSession);
            setIsLoggedIn(true);
        }
    }, [setIsLoggedIn, setUserName]);

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const handleLogout = () => {
        sessionStorage.removeItem('auth-token');
        sessionStorage.removeItem('name');
        sessionStorage.removeItem('email');
        setIsLoggedIn(false);
        setUserName('');
        navigate('/app');
    };

    const initials = userName
        ? userName.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
        : '';

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="navbar-giftlink" id="navbar_container">
            <div className="navbar-giftlink__inner">
                <Link className="navbar-giftlink__brand" to="/app">
                    <Logo size={28} className="navbar-giftlink__logo" />
                    GiftLink
                </Link>

                <button
                    className="navbar-giftlink__toggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={menuOpen}
                >
                    <span /><span /><span />
                </button>

                <div className={`navbar-giftlink__menu ${menuOpen ? 'navbar-giftlink__menu--open' : ''}`}>
                    <ul className="navbar-giftlink__links">
                        <li>
                            <a className="navbar-giftlink__link" href="/home.html">Home</a>
                        </li>
                        <li>
                            <Link
                                className={`navbar-giftlink__link ${isActive('/app') || isActive('/') ? 'navbar-giftlink__link--active' : ''}`}
                                to="/app"
                            >
                                Browse
                            </Link>
                        </li>
                        <li>
                            <Link
                                className={`navbar-giftlink__link ${isActive('/app/search') ? 'navbar-giftlink__link--active' : ''}`}
                                to="/app/search"
                            >
                                Search
                            </Link>
                        </li>
                    </ul>

                    <div className="navbar-giftlink__auth">
                        {isLoggedIn ? (
                            <>
                                <div className="navbar-giftlink__user" onClick={() => navigate('/app/profile')}>
                                    <span className="navbar-giftlink__user-avatar">{initials}</span>
                                    {userName}
                                </div>
                                <button className="navbar-giftlink__btn navbar-giftlink__btn--logout" onClick={handleLogout}>
                                    Sign out
                                </button>
                            </>
                        ) : (
                            <>
                                <Link className="navbar-giftlink__btn navbar-giftlink__btn--login" to="/app/login">Sign in</Link>
                                <Link className="navbar-giftlink__btn navbar-giftlink__btn--register" to="/app/register">Register</Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}
